import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { AuthStore } from '@core/auth/auth-store';
import { ApiClient } from '@core/services/api-client';
import { JwtDecoderService } from '@core/services/jwt-decoder-service';
import { Button } from '@shared/components/button/button';

@Component({
  selector: 'app-admin-navbar',
  templateUrl: './admin-navbar.html',
  imports: [RouterLinkActive, RouterLink, Button],
})
export class AdminNavbar implements OnInit {
  private jwtDecoder = inject(JwtDecoderService);
  private apiClient = inject(ApiClient);
  private router = inject(Router);
  private authStore = inject(AuthStore);

  token: string | null = null;
  email: string | null = null;
  role: string | null = null;

  async ngOnInit(): Promise<void> {
    this.token = localStorage.getItem('accessToken');
    this.role = this.jwtDecoder.getUserRole(this.token!);
    this.email = this.jwtDecoder.getUserEmail(this.token!);
  }

  getRoleUpperCase() {
    return this.role ? this.role.toUpperCase() : '';
  }

  getUserTwoFirstLetter() {
    return this.email
      ? (this.email.charAt(0) + this.email.charAt(1)).toUpperCase()
      : this.role
        ? (this.role.charAt(0) + this.role.charAt(1)).toUpperCase()
        : '';
  }

  async logout() {
    try {
      await this.apiClient.logout();
    } catch (error) {
      console.log('Logout API error:', error);
    } finally {
      this.authStore.clearAccessToken();
      this.router.navigate(['/login']);
    }
  }
}
